import { useState, useEffect } from "react";
import { motion, useReducedMotion } from "framer-motion";
import "./Videos.css";
import Ben from "../pages/assets/img/imagenes videos/Ben.png";
import ImgVideos from "./assets/img/imagenes home/ImgVideos.jpeg";
import YouTubePlaylistEmbed from "../components/YouTubePlaylistEmbed";
import CardCarousel from "../components/CardCarousel";
import AppCardVideo from "../components/AppCardVideo";
import ContenidoExtra from "../components/ContenidoExtra";
import { getConfigPagina, getPlaylistVideos, mergeVideoDescripciones, isApiConfigured } from "../services/api";

const defaultVideos = Array(6).fill({ thumbnail: ImgVideos, title: "", descripcion: "", videoId: null });

const DEFAULT_CANCIONES_TITULO = "Escucha cada canción";
const DEFAULT_CANCIONES_SUBTITULO = "Elige tu favorita y disfrútala las veces que quieras.";

function Videos() {
  const [config, setConfig] = useState({
    titulo: null,
    subtitulo: null,
    imagen: null,
    contenido_extra: null,
    playlist_youtube_id: null,
    lista_titulo: null,
    lista_subtitulo: null,
  });
  const [videos, setVideos] = useState(defaultVideos);
  const shouldReduceMotion = useReducedMotion();

  const sectionVariants = {
    hidden: { opacity: 0, y: shouldReduceMotion ? 0 : 40 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: shouldReduceMotion ? 0.2 : 0.6,
        ease: [0.22, 1, 0.36, 1],
        staggerChildren: shouldReduceMotion ? 0 : 0.15,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: shouldReduceMotion ? 0 : 24 },
    show: {
      opacity: 1,
      y: 0,
      transition: { duration: shouldReduceMotion ? 0.2 : 0.5, ease: "easeOut" },
    },
  };

  useEffect(() => {
    if (!isApiConfigured()) return;
    getConfigPagina("musica")
      .then((cfg) => {
        if (cfg) setConfig(cfg);
        return Promise.all([
          cfg,
          cfg?.playlist_youtube_id ? getPlaylistVideos(cfg.playlist_youtube_id, 12) : [],
        ]);
      })
      .then(([cfg, data]) => {
        if (data.length > 0) setVideos(mergeVideoDescripciones(data, cfg?.videos_descripciones));
      })
      .catch(() => {});
  }, []);

  return (
    <div className="videos">
      <motion.div
        initial="hidden"
        animate="show"
        variants={sectionVariants}
      >
        <motion.div className="videos-wrapper" variants={itemVariants}>
          <h1 className="videos-title">
            {config.titulo || "Videos musicales de Balloon y Ben"}
          </h1>
        </motion.div>
        <motion.div className="ben-container" variants={itemVariants}>
          <img src={config.imagen || Ben} alt="Ben" className="ben" />
        </motion.div>
        <motion.div className="videos-descripciones" variants={itemVariants}>
          <h3 className="videos-descripcion">
            {config.subtitulo || "Canta, ríe y aprende junto a Balloon y Ben. Descubre sus aventuras musicales, explora los sonidos del mundo natural y comparte en familia momentos llenos de curiosidad y diversión."}
          </h3>
        </motion.div>
        <ContenidoExtra html={config.contenido_extra} variants={itemVariants} />
        <motion.div variants={itemVariants}>
          <YouTubePlaylistEmbed
            playlistId={config.playlist_youtube_id}
            title="Videos musicales de Balloon y Ben"
          />
        </motion.div>
      </motion.div>

      <motion.div
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.2 }}
        variants={sectionVariants}
      >
        <motion.h2 className="videos-canciones-title" variants={itemVariants}>
          {config.lista_titulo || DEFAULT_CANCIONES_TITULO}
        </motion.h2>
        <motion.p className="videos-canciones-subtitle" variants={itemVariants}>
          {config.lista_subtitulo || DEFAULT_CANCIONES_SUBTITULO}
        </motion.p>
        <motion.div variants={itemVariants}>
          <CardCarousel
            items={videos}
            itemsPerSlide={3}
            renderItem={(v, j) => (
              <AppCardVideo
                key={j}
                thumbnail={v.thumbnail}
                title={v.title}
                descripcion={v.descripcion}
                videoId={v.videoId}
              />
            )}
          />
        </motion.div>
      </motion.div>
    </div>
  );
}

export default Videos;
